import { Routes } from '@angular/router';
import { Home } from './pages/home/home';
import { Contact } from './pages/contact/contact';
import { Faq } from './pages/faq/faq';
import { LjohOnline } from './pages/ljoh-online/ljoh-online';
import { Privacy } from './pages/privacy/privacy';
import { Returns } from './pages/returns/returns';
import { Terms } from './pages/terms/terms';
import { Why } from './pages/why/why';

export const routes: Routes = [
  { path: '', component: Home },
  { path: 'contact', component: Contact },
  { path: 'faq', component: Faq },
  { path: 'ljoh_online', component: LjohOnline },
  { path: 'privacy', component: Privacy },
  { path: 'returns', component: Returns },
  { path: 'terms', component: Terms },
  { path: 'why', component: Why },
  // The old route table had no fallback at all, so an unknown path rendered
  // an empty outlet below the header. Send them home instead.
  { path: '**', component: Home },
];
